import { lazy } from "common/load/componentUtils";
import { PromotionKind } from "common/types/promotions";

import { useDrawer } from "client/common/hooks/stackables";

import type { RebateDrawerProps } from "../components/RebateDrawer";
import type { IncentiveDrawerProps } from "../components/IncentiveDrawer";

const RebateDetailDrawer = lazy(() => import("../components/RebateDrawer"));
const IncentiveDetailDrawer = lazy(() => import("../components/IncentiveDrawer"));

export const useRebateDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: RebateDrawerProps) => open(RebateDetailDrawer, props),
  };
};

export const useIncentiveDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: IncentiveDrawerProps) => open(IncentiveDetailDrawer, props),
  };
};

type PromotionDrawerProps =
  | ({ kind: PromotionKind.Incentive } & IncentiveDrawerProps)
  | ({ kind: PromotionKind.Rebate } & RebateDrawerProps);

export const usePromotionDrawer = () => {
  const rebateDrawer = useRebateDrawer();
  const incentiveDrawer = useIncentiveDrawer();

  const kindToDrawer = {
    [PromotionKind.Rebate]: rebateDrawer,
    [PromotionKind.Incentive]: incentiveDrawer,
  };

  return {
    open: ({ kind, ...rest }: PromotionDrawerProps) => {
      const drawer = kindToDrawer[kind];
      drawer.open(rest);
    },
  };
};
